export default __webpack_public_path__ + "static/media/ModalImage22.79d6c473.jpg";